module.exports = global["NutsToolOrigin"] = require("-!/Users/gusonglin/nuts-tool-origin/node_modules/babel-loader/lib/index.js!/Users/gusonglin/nuts-tool-origin/node_modules/eslint-loader/index.js!./index.js");


//////////////////
// WEBPACK FOOTER
// ./src/index.js
// module id = 40
// module chunks = 0